<form [formGroup]="form">
    <app-picklist [formControl]="form.controls['selectedMainEquipments']"
                  [source]="availableMainEquipments"
                  formControlName="selectedMainEquipments"
                  displayField="nameWithLine"
                  sourceHeader="{{'admin.tools.create-modal.pick-list.equipment.leftHeader' | translate}}"
                  targetHeader="{{'admin.tools.create-modal.pick-list.equipment.rightHeader' | translate}}"
                  [disabled]="disabled">
    </app-picklist>
</form>
